module.exports = __webpack_public_path__ + "static/img/img-logo.48657b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img-logo.png
// module id = gnzG
// module chunks = 1